// Copyright (C) 2020-2022 Intel Corporation
// Copyright (C) 2023 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import Icon from '@ant-design/icons';
import { toggleImageFilterDialog } from 'actions/settings-actions';
import { registerComponentShortcuts } from 'actions/shortcuts-actions';
import CVATTooltip from 'components/common/cvat-tooltip';
import { FilterIcon } from 'icons';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CombinedState } from 'reducers';
import { subKeyMap } from 'utils/component-subkeymap';
import { ShortcutScope } from 'utils/enums';
import GlobalHotKeys from 'utils/mousetrap-react';

const componentShortcuts = {
    IMAGE_FILTER_CONTROLS: {
        name: 'Image Setting',
        description: 'Show image setting panel',
        sequences: ['alt+s'],
        scope: ShortcutScope.IMAGE_SETUP,
    },
};

registerComponentShortcuts(componentShortcuts);

function ImageFilterControl(): JSX.Element {
    const dispatch = useDispatch();
    const { keyMap, normalizedKeyMap } = useSelector((state: CombinedState) => state.shortcuts);

    const openImageFilterDialog = useCallback(() => {
        dispatch(toggleImageFilterDialog(true));
    }, []);

    const handlers: Record<keyof typeof componentShortcuts, (event?: KeyboardEvent) => void> = {
        IMAGE_FILTER_CONTROLS: (event: KeyboardEvent | undefined) => {
            if (event) event.preventDefault();
            openImageFilterDialog();
        },
    };

    return (
        <>
            <GlobalHotKeys keyMap={subKeyMap(componentShortcuts, keyMap)} handlers={handlers} />
            <CVATTooltip title={`Image Setting  ${normalizedKeyMap.IMAGE_FILTER_CONTROLS}`} placement='right'>
                <Icon
                    className='cvat-image-filter-control'
                    onClick={() => openImageFilterDialog()}
                    component={FilterIcon}
                />
            </CVATTooltip>
        </>
    );
}

export default React.memo(ImageFilterControl);
